import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getStimulus = async (focusGroupId, stimulusId) => {
    if (!stimulusId) {
        return null;
    }

    const { data } = await vlqrApi.get(`reports/${focusGroupId}/stimulus/${stimulusId}`)
        .catch((error) => {
            handleError(error);
        });

    return data;
};

const useStimulus = (focusGroupId, stimulusId) => {
    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: ['stimulus', stimulusId],
        queryFn: () => getStimulus(focusGroupId, stimulusId)
    });

    return { data, refetch, isLoading, isError };
};

export default useStimulus;